import React, { useEffect, useState } from "react";
import * as microsoftTeams from "@microsoft/teams-js";
import Router from "./components/Router";

function TeamsApp() {
  const [user, setUser] = useState<{ displayName?: string; email: string } | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [token, setToken] = useState<string | null>(null);

  useEffect(() => {
    const init = async () => {
      const inTeams = window.self !== window.top;
      if (!inTeams) {
        setError("Vui lòng mở ứng dụng bên trong Microsoft Teams.");
        return;
      }

      try {
        await microsoftTeams.app.initialize();
        const ctx = await microsoftTeams.app.getContext();

        // Fallback-only auth: derive identity from Teams context (no SSO token)
        const email =
          (ctx as any)?.user?.userPrincipalName ||
          (ctx as any)?.user?.loginHint ||
          (ctx as any)?.user?.id || null;
        const displayName = (ctx as any)?.user?.displayName || undefined;

        if (!email) {
          setError("Không thể xác định tài khoản từ Teams context.");
          return;
        }
        setUser({ email, displayName });

        // Try to get SSO auth token from Teams so we can display it in the UI
        microsoftTeams.authentication.getAuthToken({
          successCallback: (result) => {
            setToken(result);
          },
          failureCallback: (reason) => {
            console.error("Failed to get auth token:", reason);
          },
        });
      } catch (e) {
        setError("Khởi tạo Teams SDK thất bại.");
      }
    };

    init();
  }, []);


  if (error) {
    return (
      <div style={{ padding: 16, color: "#fff", fontFamily: "Segoe UI, Arial" }}>
        <p style={{ color: "#ff6b6b" }}>{error}</p>
      </div>
    );
  } 

  if (!user) {
    return (
      <div style={{ padding: 16, color: "#fff", fontFamily: "Segoe UI, Arial" }}>
        <p>Đang kiểm tra đăng nhập...</p>
      </div>
    );
  }

  return (
    <Router
      userEmail={user.email}
      displayName={user.displayName}
      token={token || undefined}
    />
  );
}

export default TeamsApp;


